var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16.667,
    viewBox: "0 0 20 16.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270",
    transform: "translate(-1320 -1011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    transform: "translate(1321.25 1018.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M1327.751,1023.547a.417.417,0,0,1-.226-.768,6.813,6.813,0,0,1,2.153-.9.417.417,0,1,1,.188.813,5.933,5.933,0,0,0-1.89.792A.42.42,0,0,1,1327.751,1023.547Z",
    transform: "translate(-1322.472 -1019.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M1335.677,1023.547a.42.42,0,0,1-.225-.066,5.932,5.932,0,0,0-1.89-.792.417.417,0,1,1,.188-.812,6.812,6.812,0,0,1,2.153.9.417.417,0,0,1-.226.768Z",
    transform: "translate(-1323.456 -1019.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M1339.382,1028.19a.418.418,0,0,1-.407-.323,5.934,5.934,0,0,0-.792-1.89.417.417,0,0,1,.7-.451,6.816,6.816,0,0,1,.9,2.153.417.417,0,0,1-.312.5A.4.4,0,0,1,1339.382,1028.19Z",
    transform: "translate(-1324.269 -1020.472)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M1324.282,1028.19a.4.4,0,0,1-.093-.011.417.417,0,0,1-.312-.5,6.813,6.813,0,0,1,.9-2.153.417.417,0,0,1,.7.451,5.934,5.934,0,0,0-.792,1.89A.418.418,0,0,1,1324.282,1028.19Z",
    transform: "translate(-1321.894 -1020.473)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M1334.491,1030.1a.421.421,0,0,1-.078-.007.416.416,0,0,1-.332-.487,1.887,1.887,0,0,0,.026-.339,2.842,2.842,0,0,0-5.683,0,1.9,1.9,0,0,0,.026.339.416.416,0,1,1-.818.155,2.676,2.676,0,0,1-.041-.494,3.675,3.675,0,1,1,7.35,0,2.687,2.687,0,0,1-.041.494A.416.416,0,0,1,1334.491,1030.1Z",
    transform: "translate(-1322.515 -1020.515)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M1333.076,1022.3a.416.416,0,0,1-.417-.417v-1.554h-2.065v1.554a.417.417,0,1,1-.833,0v-1.971a.416.416,0,0,1,.417-.417h2.9a.416.416,0,0,1,.417.417v1.971A.416.416,0,0,1,1333.076,1022.3Z",
    transform: "translate(-1322.877 -1019.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M1338.125,1025.478a.417.417,0,0,1-.293-.712l1.11-1.1-1.46-1.46-1.1,1.11a.417.417,0,0,1-.591-.587l1.4-1.406a.414.414,0,0,1,.3-.123h0a.414.414,0,0,1,.294.122l2.051,2.051a.415.415,0,0,1,0,.59l-1.406,1.4A.416.416,0,0,1,1338.125,1025.478Z",
    transform: "translate(-1323.861 -1019.782)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M1341.522,1030.46a.417.417,0,0,1-.417-.417v-1.45h-1.558a.417.417,0,1,1,0-.833h1.975a.416.416,0,0,1,.417.417v1.867A.417.417,0,0,1,1341.522,1030.46Z",
    transform: "translate(-1324.438 -1020.877)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M1321.917,1030.46a.417.417,0,0,1-.417-.417v-1.867a.416.416,0,0,1,.417-.417h1.975a.417.417,0,1,1,0,.833h-1.558v1.45A.417.417,0,0,1,1321.917,1030.46Z",
    transform: "translate(-1321.5 -1020.877)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M1325.018,1025.478a.417.417,0,0,1-.294-.122l-1.406-1.4a.415.415,0,0,1,0-.59l2.051-2.051a.413.413,0,0,1,.294-.122h0a.414.414,0,0,1,.3.123l1.4,1.406a.417.417,0,1,1-.591.587l-1.1-1.11-1.46,1.46,1.11,1.1a.417.417,0,0,1-.293.712Z",
    transform: "translate(-1321.782 -1019.782)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M1338.75,1027.667h-17.5a1.251,1.251,0,0,1-1.25-1.25v-15a.417.417,0,0,1,.417-.417h19.167a.417.417,0,0,1,.417.417v15A1.251,1.251,0,0,1,1338.75,1027.667Zm-17.917-15.833v14.583a.418.418,0,0,0,.417.417h17.5a.418.418,0,0,0,.417-.417v-14.583Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M1339.583,1015.833h-19.167a.417.417,0,0,1,0-.833h19.167a.417.417,0,1,1,0,.833Z",
    transform: "translate(0 -0.667)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 0.417,
    cy: 0.417,
    r: 0.417,
    transform: "translate(1322.5 1012.667)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 0.417,
    cy: 0.417,
    r: 0.417,
    transform: "translate(1324.167 1012.667)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 0.417,
    cy: 0.417,
    r: 0.417,
    transform: "translate(1325.833 1012.667)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.b35c06c98fa24ba1cc14a00fab363e95.svg";
export { ForwardRef as ReactComponent };